<template>
  <b-col class="m-auto">
    <slot name="logo"></slot>
    <template v-if="isPassowrdExpiration">
      <h4 class="text-muted">{{ labels.expirationTitle }}</h4>
      <p class="pb-4">{{ labels.expirationText }}</p>
    </template>
    <template v-else>
      <h4 class="text-muted pb-4">{{ labels.recoverTitle }}</h4>
    </template>

    <b-form @submit.prevent="login">
      <CustomInput
        type="text"
        v-model="form.email"
        tabindex="1"
        :label="labels.emailCode"
        :labelWrong="labels.emailCodeWrong"
        :aria-label="labels.emailCodeHelp"
      />

      <b-tooltip target="text">
        <div class="tooltip-info">
          {{ labels.emailCodeHelp }}
        </div>
      </b-tooltip>

      <b-row role="alert" v-if="message" align-h="center">
        <span class="text-secondary error-message">{{ message }}</span>
      </b-row>

      <b-button
        id="btn-send"
        @keyup.enter.prevent="submit"
        variant="quartenary"
        :disabled="submitInProgress"
        type="submit"
        class="col-12 mt-3 text-white"
      >
        <i
          class="mdi mdi-spin pr-2"
          :class="{ 'mdi-loading': submitInProgress }"
        ></i
        >{{ labels.send }}
      </b-button>
    </b-form>

    <b-row align-h="center" class="mt-3 mb-3">
      <b-col>
        <b-link id="backToLogin" :to="{ name: 'login.auth' }">{{
          labels.returnToLogin
        }}</b-link>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomInput from '@/components/Shared/Form/CustomInput.vue'
import { sendPassword } from '@/service/account'
import unconfirmedValidation from '@/helpers/unconfirmedValidation'
import { AuthErrorCodes } from '@/helpers/authErrorCodes'

export default {
  components: {
    CustomInput,
  },

  mounted() {
    this.$root.$emit('setPageTitle', { context: this, path: 'resetPassword' })
  },

  data: function() {
    return {
      submitInProgress: false,
      message: null,
      form: {
        email: this.$route.params.email,
      },
    }
  },
  computed: {
    ...mapGetters(['resources']),

    isPassowrdExpiration: function() {
      return this.$route.query.code === AuthErrorCodes.PasswordExpired
    },

    labels: function() {
      return Object.assign(
        {},
        this.resources.page.login.password,
        this.resources.general.input,
        this.resources.general.buttons,
        this.resources.page.login.new
      )
    },
  },
  methods: {
    async login() {
      if (this.submitInProgress) return false

      this.submitInProgress = true
      this.message = null

      try {
        const response = await sendPassword(this.form.email)
        const { question = false, token = false } = response

        if (question) {
          return this.$router.push({
            name: 'login.password.secret-question',
            query: { login: this.form.email },
          })
        }

        return token
          ? this.$router.push({
              name: 'login.confirm.account',
              params: { token },
            })
          : this.$router.push({ name: 'login.password.sent' })
      } catch (error) {
        unconfirmedValidation(this, error)
        this.message = error.message
      }
      this.submitInProgress = false
    },
  },
}
</script>

<style scoped lang="scss">
/deep/ .custom-input-label {
  font-size: 12px;
  top: -18px;
}
</style>
